import { projectVersions, projectTypes } from '@/Models';
import SettingsBoxBase from '@/Components/Admin/SettingsBoxBase';
import { mapState } from 'pinia';
import { useAdminProjectContextStore } from '@/Stores/Admin/projectContextStore';

export default {
    extends: SettingsBoxBase,
    computed: {
        isCrowdfunding() {
            return this.projectContext.project && this.projectContext.project.type === projectTypes.crowdfunding;
        },
        isPledgeManager() {
            return this.projectContext.project && this.projectContext.project.type === projectTypes.pledgeManager;
        },
        projectID() {
            return this.projectContext.projectID;
        },
        isv2() {
            return this.projectContext?.project?.version === projectVersions.v2;
        },
        isv1() {
            return this.projectContext?.project?.version === projectVersions.v1;
        },
        isCFOriginalType() {
            return this.projectAdditionalInfo?.originalType === projectTypes.crowdfunding;
        },
        isPMOriginalType() {
            return this.projectAdditionalInfo?.originalType === projectTypes.pledgeManager;
        },
        isExternalV2Campaign() {
            return this.isPMOriginalType && this.isv2;
        },
        ...mapState(useAdminProjectContextStore, ['isStore']),
    },
    methods: {
        loadSettings() {
            if (this.projectID) {
                return this.loadSettingsBase();
            }
            return Promise.resolve();
        },
    },
    watch: {
        'projectContext.projectID'() {
            this.loadSettings();
        },
    },
};
